import { render, staticRenderFns } from "./VizModePie.vue?vue&type=template&id=7188df31&scoped=true&"
import script from "./VizModePie.vue?vue&type=script&lang=js&"
export * from "./VizModePie.vue?vue&type=script&lang=js&"
import style0 from "./VizModePie.vue?vue&type=style&index=0&id=7188df31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188df31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VMenu,VTooltip})
